import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Gift, Check } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'The 3PM Reset Checklist',
    image: 'https://cdn.magicpatterns.com/uploads/mZqGwT3m4xzkPu7dLVM9MS/Bono_1.png',
    description: '¿Conoces ese momento exacto en que son las 3 de la tarde y tu cerebro simplemente se apaga? No puedes concentrarte. Saltas de tarea en tarea. Sientes una presión sorda en el pecho y sabes que las próximas 3 horas de trabajo van a ser un desperdicio. Esta checklist fue diseñada para ese momento exacto. 9 pasos. 3 minutos. Una sola página. No necesitas levantarte del escritorio. No necesitas cerrar tu laptop. No necesitas motivación. Ejecutas el paso 1, pasas al 2, y así hasta el 9. Cuando terminas, tu sistema nervioso ya cambió de estado. La neblina se fue. Vuelves al trabajo.',
    bullets: ['Sin teoría', 'Sin explicaciones largas', 'Diseñada para ejecutarse con una mano mientras tienes la otra en el teclado', 'Funciona en la primera ejecución'],
    quote: 'No entiendo cómo algo tan simple funciona tan rápido.'
  }, {
    title: 'CEO Sleep Protocol — Guía de 5 Minutos',
    image: 'https://cdn.magicpatterns.com/uploads/jhwDQbjPGPPvTE465RX7jg/imagen_bono_2.1.png',
    description: 'El problema no es que no puedas dormir. El problema es que tu cerebro ejecutivo no sabe cómo apagarse. Llevas 12 horas tomando decisiones, resolviendo problemas y anticipando riesgos. Y cuando finalmente te acuestas, tu mente sigue corriendo: repasando conversaciones, calculando números, anticipando el día de mañana. Eso no es insomnio. Es un sistema nervioso que nadie le enseñó a desconectarse. Esta guía de una sola página tiene 6 acciones secuenciales para apagar tu cerebro ejecutivo al final del día.',
    bullets: ['La ejecutas en la cama', 'Sin pantallas', 'Sin apps', 'Sin ruido blanco', 'Sin pastillas', 'Funciona aunque hayas tenido el día más caótico de tu vida'],
    closing: 'Cuando terminas la secuencia, tu cuerpo ya recibió la señal biológica de que el día terminó. El sueño llega solo. Y mañana despiertas con claridad total. No aturdido. No arrastrándote. Listo para operar.'
  }, {
    title: 'High-Performance Morning Checklist',
    image: 'https://cdn.magicpatterns.com/uploads/axRbfSC2nZStDYA4jm9WZq/Bono_3.png',
    description: 'La mayoría de emprendedores empieza el día en modo reactivo. Abren el teléfono, revisan mensajes, leen emails y en 4 minutos ya están respondiendo a la agenda de otros. Ya perdieron el control del día antes de desayunar. Esta checklist existe para que eso no vuelva a pasarte. 7 pasos. 7 minutos. Un solo objetivo: arrancar en modo enfoque. Cada paso activa un estado fisiológico diferente. No es motivación. No es mentalidad positiva. Es biología aplicada a tu rendimiento. Cuando terminas el paso 7, ya estás operando. Tu corteza prefrontal está activa. Tu cortisol matutino está regulado. Tu enfoque está encendido.',
    bullets: ['Sin ritual espiritual', 'Sin rutina de 2 horas', 'Sin motivación requerida', 'Lista para usar mañana mismo', 'Compatible con cualquier horario, incluso los más caóticos'],
    closing: 'Esto es lo que hace la diferencia entre un CEO que reacciona todo el día y uno que ejecuta con intención desde la primera hora.'
  }];
  return <Section background="white" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal-dark mb-6" data-id="element-13">
            Pero eso no es todo.
          </h2>
          <p className="text-lg md:text-xl text-brand-charcoal/80 mb-4 max-w-3xl mx-auto" data-id="element-14">
            Cuando obtienes acceso a Cortisol Off hoy, también recibes estos 3
            bonos de ejecución inmediata — completamente gratis.
          </p>
          <p className="text-brand-gold-dark font-medium" data-id="element-15">
            (Valorados en $141 en total. Tuyos hoy sin costo adicional.)
          </p>
        </motion.div>

        <div className="space-y-24" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-10 md:gap-16 items-center`} data-id="element-17">
              <div className="w-full md:w-1/2" data-id="element-18">
                <div className="rounded-xl overflow-hidden shadow-2xl border border-brand-gold/10 bg-brand-cream-dark" data-id="element-19">
                  <img src={bonus.image} alt={bonus.title} className="w-full aspect-[4/3] object-cover object-center block" data-id="element-20" />
                </div>
              </div>

              <div className="w-full md:w-1/2" data-id="element-21">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-brand-gold/10 text-brand-gold-dark rounded-full text-sm font-bold mb-4" data-id="element-22">
                  <Gift className="h-4 w-4" data-id="element-23" />
                  <span data-id="element-24">BONO #{index + 1} — GRATIS</span>
                </div>

                <h3 className="text-2xl md:text-3xl font-serif font-bold text-brand-charcoal-dark mb-2" data-id="element-25">
                  {bonus.title}
                </h3>

                <p className="text-sm font-medium text-brand-charcoal/50 mb-6 pb-6 border-b border-brand-gold/20" data-id="element-26">
                  Valor real: $47 —{' '}
                  <span className="text-brand-gold-dark font-bold" data-id="element-27">
                    Hoy: GRATIS
                  </span>
                </p>

                <p className="text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-28">
                  {bonus.description}
                </p>

                <ul className="space-y-3 mb-6" data-id="element-29">
                  {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-30">
                      <Check className="h-5 w-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-31" />
                      <span className="text-brand-charcoal/80 font-medium" data-id="element-32">
                        {bullet}
                      </span>
                    </li>)}
                </ul>

                {bonus.quote && <div className="bg-brand-cream p-4 rounded-lg border-l-4 border-brand-gold italic text-brand-charcoal/70" data-id="element-33">
                    "{bonus.quote}"
                  </div>}

                {bonus.closing && <p className="text-brand-charcoal-dark font-medium leading-relaxed" data-id="element-34">
                    {bonus.closing}
                  </p>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}